export default {
  root: ({ props, context, parent }) => ({
    class: [
      // Font
      'leading-none',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name == 'InputGroup' },

      // Spacing
      'm-0',
      {
        'py-4 px-5 text-xl': props.size == 'xl',
        'py-3 px-3.5 text-lg': props.size == 'large',
        'py-1.5 px-2': props.size == 'small',
        'py-2 px-3': props.size == null
      },

      // Shape
      { 'rounded-md': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md':
          parent.instance.$name == 'InputGroup'
      },
      {
        'border-0 border-y border-l last:border-r':
          parent.instance.$name == 'InputGroup'
      },
      {
        'first:ml-0 -ml-px':
          parent.instance.$name == 'InputGroup' && !props.showButtons
      },

      // Colors
      'text-brand-text dark:text-white/70',
      'placeholder:text-brand-placeholder/50 dark:placeholder:text-white/40',
      { 'bg-surface-0 dark:bg-slate-700': !context.disabled },
      'border',
      { 'border-surface-300 dark:border-slate-800': !props.invalid },

      // Invalid State
      'invalid:focus:ring-red-200',
      'invalid:hover:border-red-500',
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'hover:border-surface-400 dark:hover:border-surface-600':
          !context.disabled && !props.invalid,
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:z-10':
          !context.disabled,
        'bg-surface-200 dark:bg-surface-700 select-none pointer-events-none cursor-default':
          context.disabled
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name == 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
}
